import { defineMessages, useIntl } from "react-intl";

export const messages = defineMessages({
  hispanic: {
    id: "Patient.EditForm.ethnicityHispanic",
    defaultMessage: "Hispanic",
  },
  none: {
    id: "Patient.EditForm.ethnicityNone",
    defaultMessage: "None",
  },
  other: {
    id: "Patient.EditForm.ethnicityOther",
    defaultMessage: "Other",
  },
  ratherNotSay: {
    id: "Patient.EditForm.ethnicityRatherNotSay",
    defaultMessage: "Rather not say",
  },
});

export const useEthnicityTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = {
    hispanic: formatMessage(messages.hispanic),
    none: formatMessage(messages.none),
    other: formatMessage(messages.other),
    rather_not_say: formatMessage(messages.ratherNotSay),
  };

  return translations;
};
